<template>
  <div class="container">
    <div class="scan-head trans">
      <scan-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />
      <div class="scan-content">
        <div class="scan-info">
          <h2 class="tit"><i class="city ct-cuowu"></i>不能完成签到</h2>
          <span>原因: 未缴费</span>
          <div class="list">
            <div class="item">姓名</div>
            <div class="item">手机号</div>
            <div class="item">缴费状态</div>
            <div class="item">参观报名信息</div>
          </div>
        </div>
        <el-button class="handleSubmit">继续扫一扫</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import scanHeader from "@/components/header"
  export default {
    name: "scanFail",
    components: {
      scanHeader,
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "扫码入场",
        },
      }
    },

    methods: {
      handleClickIocn() {
        history.go(-1)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .scan-content {
    margin: 0 15px;

    .scan-info,
    .scan-reason {
      margin-top: 30px;

      .tit {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        color: var(--main-color);

        .city {
          position: relative;
          margin: 0 15px;
          color: #fff;
          font-size: 24px;

          &:after {
            content: "";
            position: absolute;
            top: -2px;
            left: -4px;
            width: 30px;
            height: 30px;
            background: var(--main-color);
            z-index: -1;
            border-radius: 50%;
          }
        }
      }

      span {
        display: block;
        margin-top: 15px;
        text-align: center;
      }
    }

    .list {
      margin-top: 30px;
      background: #fff;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
      padding: 15px;
      border-radius: 5px;
      box-sizing: border-box;

      .item {
        line-height: 30px;
        margin-top: 10px;
        border-bottom: 1px solid #f2f3f3;

        &:first-child {
          margin-top: 0;
        }
      }
    }

    ::v-deep .el-textarea__inner {
      margin-top: 15px;
      height: 80px;
      &:focus {
        border-color: var(--main-color);
      }
    }

    .handleSubmit {
      width: 100%;
      margin-top: 30px;
      background: var(--main-color);
      color: #fff;
    }
  }
</style>
